module.exports = __webpack_public_path__ + "img/footer box@3x.4b53a0fb.png";